import {
  useMemo
} from 'react';

const useRandom = ({
  arrToFilter = [],
  currentId = '',
  countToDisplay = 3
}) => {
  const arrFiltered = useMemo(
    () => arrToFilter.filter(
      (item) => item.id !== currentId
    ),
    [currentId, arrToFilter]
  );

  const arrToDisplay = useMemo(
    () => arrFiltered.sort(() => Math.random() - Math.random()).slice(0, countToDisplay),
    [arrFiltered, countToDisplay]
  );

  return arrToDisplay;
};

export default useRandom;
